import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { metaConsent, metaTrack } from "@/lib/metaPixel";

const STORAGE_KEY = "lsh_cookie_consent";

const applyConsent = (granted) => {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: granted ? "granted" : "denied",
      ad_user_data: granted ? "granted" : "denied",
      ad_personalization: granted ? "granted" : "denied",
      analytics_storage: granted ? "granted" : "denied",
    });
  }
  // Meta Pixel: allinea il consenso nativo e invia il PageView solo dopo ACCETTA
  metaConsent(granted);
  if (granted) {
    metaTrack("PageView");
    try { window.dispatchEvent(new Event("lsh-consent-granted")); } catch {}
  }
};

const CookieConsent = () => {
  const { lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved !== "granted" && saved !== "denied") setVisible(true);
    } catch { setVisible(true); }
  }, []);

  const choose = (granted) => {
    try { localStorage.setItem(STORAGE_KEY, granted ? "granted" : "denied"); } catch {}
    applyConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  const en = lang === "en";
  return (
    <div data-testid="cookie-consent-banner" className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4">
      <div className="mx-auto max-w-3xl rounded-2xl border border-brand-navy/10 bg-white shadow-xl p-4 sm:p-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex-1">
            <p className="flex items-center gap-2 text-sm font-semibold text-brand-navy">
              <Cookie className="h-4 w-4 text-brand-electric" /> {en ? "We value your privacy" : "Rispettiamo la tua privacy"}
            </p>
            <p className="mt-1 text-xs text-brand-navy/60 leading-relaxed">
              {en
                ? "We use cookies for the site to work and, only with your consent, to measure advertising results. You can accept or reject marketing cookies. "
                : "Usiamo cookie per il funzionamento del sito e, solo con il tuo consenso, per misurare i risultati pubblicitari. Puoi accettare o rifiutare i cookie di marketing. "}
              <Link to="/cookie-policy" className="text-brand-electric underline">{en ? "Cookie Policy" : "Cookie Policy"}</Link>
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <Button data-testid="cookie-reject" variant="outline" onClick={() => choose(false)}
              className="rounded-full text-brand-navy border-brand-navy/20 flex-1 sm:flex-none">
              {en ? "Reject" : "Rifiuta"}
            </Button>
            <Button data-testid="cookie-accept" onClick={() => choose(true)}
              className="rounded-full bg-brand-electric hover:bg-brand-electric/90 text-white flex-1 sm:flex-none">
              {en ? "Accept" : "Accetta"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
